@if (isAdmin || showMenu()) {
  <section class="container pb-6 pl-2 pt-2">
    <app-menu/>
  </section>
}
<section class="section">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</section>
